export enum ProductPurchaseAction {
  BuyNow = 'BuyNow',
  CurrentlyActive = 'CurrentlyActive',
  CurrentlyActiveAnnual = 'CurrentlyActiveAnnual',
  UpgradeToAnnual = 'UpgradeToAnnual',
  UpgradeToFullPlan = 'UpgradeToFullPlan',
  UpgradeToBundle = 'UpgradeToBundle',
}
